import { useContext } from "react";
import context, { IAuthContext } from "./context";

export default (): IAuthContext => useContext(context);
